import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

import AliveInfo from '@/features/statistics/AliveInfo';
import AliveList from '@/features/statistics/AliveList';
import ButtonExcel from '@/features/ui/button/ButtonExcel';
import ButtonRefetch from '@/features/ui/button/ButtonRefetch';
import LoadingFrame from '@/features/ui/common/LoadingFrame';
import PageBody from '@/features/ui/layout/PageBody';
import PageHeader from '@/features/ui/layout/PageHeader';
import { useContentsModal } from '@/hooks/useContentsModal';
import { SecureStorage } from '@/plugin/crypto';
import { statisticsQueryKey } from '@/queries/_querykey';
import { postQuery } from '@/queries/_utils';
import { aliveIdState } from '@/state/alive';
import { AliveListType } from '@/types/Statistics.types';
import { getValueOrEmptyFromObject } from '@/utils/objectUtils';

export default function Alive() {
	const secureStorage = new SecureStorage(sessionStorage);
	const userInfo = secureStorage.getItem('user-storage', 'user-storage');
	const initialParams = {
		searchDTO: {
			memberFlag: getValueOrEmptyFromObject(userInfo, 'member_flag'),
			memberViewlist: getValueOrEmptyFromObject(userInfo, 'member_viewlist'),
			searchType: '',
			searchWord: '',
		},
		orderDTO: {
			orderType: '',
			orderWord: '',
		},
		pageDTO: {
			curPage: 1,
			pagePerRow: secureStorage.getItem('user-storage', 'user-storage').member_dataPerPage,
		},
	};

	const [_, setId] = useRecoilState(aliveIdState);
	const { openContentModal } = useContentsModal();

	const [params, setParams] = useState(initialParams);
	const { data, isLoading } = useQuery({
		queryKey: [...statisticsQueryKey.aliveList(), params],
		queryFn: postQuery,
	});

	const handleAliveClick = (alive: AliveListType) => {
		setId(alive.aliveNo);
		openContentModal(<AliveInfo />);
	};

	const listProps = {
		initialParams,
		params,
		data: data?.aliveList,
		pageMap: data?.pageMap,
		setParams,
		handleAliveClick,
	};

	const isMobile = /Mobi/i.test(window.navigator.userAgent);
	const isSearchWord = params.searchDTO.searchWord !== null && params.searchDTO.searchWord !== '';

	// 가로 모드   >   스크롤 이동
	useEffect(() => {
		const landscape = () => {
			if (!window.matchMedia('(orientation: portrait)').matches) {
				const page = document.querySelector('.page');
				if (page) {
					page.scrollTo({ top: 205 });
				}
			}
		};
		window.addEventListener('load', landscape);
		window.addEventListener('resize', landscape);
	}, []);

	return (
		<div className="page">
			<PageHeader title="고장 관리">
				{!isMobile ? (
					isSearchWord ? (
						<ButtonExcel
							queryKey={statisticsQueryKey.aliveExcelDown()}
							params={params}
							filename={params.searchDTO.searchWord + ' 고장 현황'}
						/>
					) : (
						<ButtonExcel queryKey={statisticsQueryKey.aliveExcelDown()} params={params} filename="고장 현황" />
					)
				) : null}
				<ButtonRefetch />
			</PageHeader>
			<PageBody title="고장 목록">
				<AliveList {...listProps} />
			</PageBody>
			{isLoading && <LoadingFrame />}
		</div>
	);
}
